import { useState, useEffect, useRef } from "react";

// Custom hook to track active time
export const useActiveTime = (isInactive) => {
    const [activeTime, setActiveTime] = useState(0);
    const intervalRef = useRef(null);
    const lastActiveTimeRef = useRef(0);
    const pausedTimeRef = useRef(0);

    useEffect(() => {
        if (!isInactive) {
            // Start the timer
            intervalRef.current = setInterval(() => {
                setActiveTime((prevTime) => {
                    // Increment by 5 seconds (not add the previous time)
                    const newTime = prevTime + 5;
                    lastActiveTimeRef.current = newTime;
                    return newTime;
                });
            }, 5000);
        } else {
            // Clear the timer if inactive
            clearInterval(intervalRef.current);
            // Store the current time when paused
            pausedTimeRef.current = activeTime;
        }

        // Cleanup
        return () => {
            clearInterval(intervalRef.current);
        };
    }, [isInactive]); // Remove activeTime from dependencies to prevent re-running the effect

    const resetActiveTime = () => {
        setActiveTime(0);
        lastActiveTimeRef.current = 0;
        pausedTimeRef.current = 0;
    };

    return [activeTime, resetActiveTime];
};